<template>
    <ns-slotted-dropdown id="variantDropdown" class="variant-dropdown" :selected-text="variantDropdownPlaceholder" :selected="variantIndex" :stay-closed="isTouchDevice">
        <paper-item class="variant-dropdown-item" v-for="item in variants" :value="item.sku" :key="item.id">
			<div class="dropdown-item-icon" :style="{ backgroundColor: item.shade }"></div>
			<div class="dropdown-item-label">{{item.variantDropdownLabel}}</div>
        </paper-item>
    </ns-slotted-dropdown>
</template>
<script>
	import Vue from 'vue';
	import {events, util} from '@nuskin/ns-util';
	import {ProductService} from '@nuskin/ns-shop';

	const nsProductVariantSelectorVue = {
		name: "nsProductVariantSelectorVue",
		props: {
			/**
			 * Placeholder text
			 */
			variantDropdownPlaceholder: "",
			/**
			 * Array of variant skus
			 */
			variantSkus: Array,
			/**
			 * Sku of the current product
			 */
			sku: "",
			/**
             * Sku component initialized with
             */
			initSku: ""
		},
		data: function() {
			return {
				/**
				 * Disables input
				 */
				disabled: false,
				/**
				 * Toggles functionality if logged in
				 */
				isLoggedIn: false,
				/**
				 * Toggles functionality if touch device
				 */
				isTouchDevice: util.MobileUtils.isMobileLike(),
				/**
				 * Dropdown label
				 */
				label: "",
				/**
				 * Returns product data from dropdown selection
				 */
				newVariant: {},
				/**
				 * Toggles the visibility of the modal
				 */
				opened: false,
				/**
				 * Variant object array
				 */
				variants: [],
				/**
				 * Which number in the dropdown is selected
				 */
				variantIndex: -1,
				/**
				 * Variant type
				 * ie: "shade", "size"
				 */
				variantType: "shade"
			}
		},
		watch: {
			variantSkus: {
			    handler: "_setVariants"
            }
		},
		methods: {
			/**
			 * Adds Product Variant Selector Modal to the DOM if it doesn't yet exist
			 */
			addProductVariantSelectorModal() {
				if (!document.querySelector('ns-product-variant-selector-modal')) {
					document.querySelector('body').appendChild(document.createElement('ns-product-variant-selector-modal'));
				}
			},
			/**
			 * Disables input
			 */
			disable() {
				$('#variantDropdown').attr('disabled', true);
			},
			/**
			 * Enables input
			 */
			enable() {
				$('#variantDropdown').attr('disabled', false);
			},
			/**
			 * Create all event listeners for this component
			 */
			setListeners() {
				if (this.isTouchDevice) {
					$('#variantDropdown').on("click", e => {
						if (!this.settingVariants) {
							this.addProductVariantSelectorModal();
							events.publish(events.shop.SHOW_PRODUCT_VARIANT_SELECTOR_MODAL, this);
						}
					});
                    events.subscribe(events.shop.HIDE_PRODUCT_VARIANT_SELECTOR_MODAL, data => {
                        if (data.originalSku === this.initSku) {
                            this.$emit('new-variant', data.newVariant);
                            this.variantIndex = data.index;
                        }
                    });
				}
				$('#variantDropdown').on('nsDropdownSelect', e => {
					if (!$('#variantDropdown[pristine]').length && !this.settingVariants)
					    this.$emit('new-variant', this.variants[e.detail.index]);
				});
			},
			/**
			 * Makes call for each sku in variant-skus array for the list
			 */
			_setVariants() {
				let index = 0;
				this.variants = [];
                this.settingVariants = true;
				this.variantSkus.map(sku => {
					ProductService.getProductData(sku).then((data) => {
						if (data.sku === this.sku) this.variantIndex = index;
						this.variants.push(data);
						index++;
                        if (this.variantSkus.length === index) {
                            this.settingVariants = false;
                        }
					});
				});
			}
		},
        mounted() {
			this.setListeners();
			if (this.variantSkus.length > 0) {
				this._setVariants();
			}
        }
	};

	export default nsProductVariantSelectorVue;

</script>

<style lang="scss" scoped>
    @import '~@nuskin/ns-core-styles/src/scss/_global.mixins';
	@import '~@nuskin/ns-core-styles/src/scss/globalVariables';

	.variant-dropdown {
		background-color: white;

		* {
			box-sizing: border-box;
			-webkit-font-smoothing: antialiased;
			color: var(--color-interactive-7);
		}
	}

    ns-slotted-dropdown.variant-dropdown{
        margin: 0;
        display: block;
        width: 100%;
		text-align: left;
		margin-top: 10px;
	}

	.variant-dropdown-item {
		display: flex;
		align-items: center;
		user-select: none;
		cursor: pointer;

		.dropdown-item-icon{
			height: 20px !important;
			width: 20px !important;
			border-radius: 50% !important;
			display: none;

			&[style*="#"],
			&[style*="rgb"]{
				display: inline-block !important;
			}
		}

		.dropdown-item-label {
			flex: 1;
			display: inline-block;
			margin-left: 10px;
			font-family: var(--p-small_-_font-family);
			font-weight: var(--p-small_-_font-weight);
			font-size: var(--p-small_-_font-size);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&:hover {
    		background-color: var(--color-interactive-5);
		}
	}
</style>
